import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiTagsService } from 'src/app/services/api-tags.service';

@Component({
  selector: 'app-tags-dialog-managment',
  templateUrl: './tags-dialog-managment.component.html',
  styleUrls: ['./tags-dialog-managment.component.css']
})
export class TagsDialogManagmentComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  orgAndProductIds:Object;
  switchTab:string = 'list'
  tagsIDs:string[] = [];

  @Input() set data(value) {
    
    if (value != null) {
      
      this.tagsIDs = value;
    }
  }

  constructor(
    private apiTagsService: ApiTagsService
  ) { }

  ngOnInit(): void {

    // СЛУШАЕМ ИЗМЕНЕНИЕ ДАННЫХ В КОМПОНЕНТАХ ДЛЯ АВТО ПЕРЕКЛЮЧЕНИЯ МЕЖДУ ВЛКАДКАМИ ОКНА
    this.subscriptions.add(
      this.apiTagsService.listenerSwitchTab().subscribe(val => {

        if(val){

          this.switchTab = val;
        }
        
      })
    );
  }

  /**
   * 
   * @param tab 
   */
   switchTabs(tab:string){

    this.switchTab = tab;

  }

}
